import SignaturePad from './SignaturePad'

export default SignaturePad
